export enum ESPressoFeatureFlags {
    UnblockUserButton = 'auth0-unblock-user-account',
    Auth0NovaSso = 'auth0-nova-sso',
    Auth0NovaLinkedProfiles = 'auth0-nova-linkedprofiles',
    Auth0NovaImpersonation = 'auth0-nova-impersonation',
    NovaUpdateEmailValidationLogic = 'nova-update-email-validation-logic',
    Auth0FixNovaImpersonationSegments = 'auth0-fix-nova-impersonation-segments',
    NovaDelegationFixSaveButton = 'nova-delegation-fix-save-button',
    NovaDelegationDateValidation = 'nova-delegation-date-validation',
    NovaDelegationTimeframe = 'nova-delegation-timeframe',
    Auth0DelegateNovaImpersonationPermission = 'auth0-delegate-nova-impersonation-permission',
    NovaDelegationIsCurrentDelegateUtcFix = 'nova-delegation-is-current-delegate-utc-fix',
    NovaRedirectCallbackToHost = 'nova-redirect-callback-to-host'
}
